import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import LoadingBackdrop from "../components/loading-backdrop";
import { ErrorContext } from "../components/app-routes";
import { adminApi, AdminWhoAmIResponse } from "../services/api/admin";

export default function AdminHomePage() {
  const { handleError } = useContext(ErrorContext);
  const [busy, setBusy] = useState(false);
  const [adminUser, setAdminUser] = useState<AdminWhoAmIResponse | null>(null);

  useEffect(() => {
    const load = async () => {
      setBusy(true);

      try {
        const res = await adminApi.whoAmI();
        setAdminUser(res);
      } catch (error) {
        handleError(error);
      } finally {
        setBusy(false);
      }
    };

    load();
  }, [handleError]);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        SeedLeaf Admin
      </Typography>

      <Card>
        <CardContent>
          {adminUser ? (
            <>
              <Typography variant="h6">Admin access confirmed</Typography>
              <Divider sx={{ my: 2 }} />

              <Typography>Name: {adminUser.name}</Typography>
              <Typography>Email: {adminUser.email}</Typography>
            </>
          ) : (
            <>
              <Typography variant="h6">Admin access not confirmed</Typography>
              <Divider sx={{ my: 2 }} />

              <Typography>
                This account has not passed the backend admin check.
              </Typography>
            </>
          )}
        </CardContent>
      </Card>

      <Card sx={{ mt: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Admin Tools
          </Typography>

          <Button component={RouterLink} to="/support-admin" variant="outlined">
            Support Admin
          </Button>
          <Button
            component={RouterLink}
            to="/admin/referrals"
            variant="outlined"
            sx={{ ml: 1 }}
          >
            Referrals Admin
          </Button>
          <Button
            component={RouterLink}
            to="/mushroom/home"
            variant="outlined"
            sx={{ ml: 1 }}
          >
            Mushroom Admin
          </Button>
        </CardContent>
      </Card>

      <LoadingBackdrop open={busy} />
    </Box>
  );
}
